/**
 * Scroll Fade Animation
 * Converted from scroll-fade.tsx
 * Uses Intersection Observer to fade in elements as they scroll into view
 */

(function() {
  'use strict';
  
  document.addEventListener('DOMContentLoaded', function() {
    // Find all elements with scroll-fade class
    const fadeElements = document.querySelectorAll('.scroll-fade');
    
    if (fadeElements.length === 0) {
      return;
    }
    
    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (prefersReducedMotion) {
      // If user prefers reduced motion, show all elements immediately
      fadeElements.forEach(function(el) {
        el.classList.add('is-visible');
      });
      return;
    }
    
    // Create intersection observer
    const observerOptions = {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.1 // Trigger when 10% of element is visible
    };
    
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          // Get delay from data attribute if present
          const delay = entry.target.dataset.delay || 0;
          
          setTimeout(function() {
            entry.target.classList.add('is-visible');
          }, delay);
          
          // Stop observing once visible
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    // Observe all fade elements — show immediately if already in viewport
    fadeElements.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('is-visible');
      } else {
        observer.observe(el);
      }
    });
  });
})();
